import React, { useState } from 'react';

import './RootPageLayout.scss';
import NavHeader from 'components/threepp/LayoutLoader/NavHeader/NavHeader';
import { NavSideBar } from 'components/common/SideBar/NavSideBar/NavSideBar';
import UserProfile from 'components/threepp/UserProfile/UserProfile';
import Help from 'components/threepp/Help/Help';
import CreateNewModal from 'components/threepp/CreateNewModal/CreateNewModal';

export const RootPageLayout = props => {
  const { children } = props;
  const [navOpen, setNavOpen] = useState(false);
  const [showUserProfileModal, setShowUserProfileModal] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [showCreateNewModal, setCreateNewModal] = useState(false);

  const onNavToggle = () => {
    setNavOpen(!navOpen);
  };

  const onUserProfileModalToggle = () => {
    setShowUserProfileModal(!showUserProfileModal);
  };

  const onHelpModalToggle = () => {
    setShowHelpModal(!showHelpModal);
  };

  const onCreateNewModalToggle = () => {
    setCreateNewModal(!showCreateNewModal);
  };

  return (
    <>
      <NavHeader
        navDrawerOpen={navOpen}
        navDrawerOnChange={onNavToggle}
        toggleUserProfileModal={onUserProfileModalToggle}
        displayHelpModal={onHelpModalToggle}
      />
      <NavSideBar
        open={navOpen}
        navDrawerOnChange={onNavToggle}
        toggleUserProfileModal={onUserProfileModalToggle}
        displayHelpModal={onHelpModalToggle}
        displayCreateNewModal={onCreateNewModalToggle}
      />
      <div className="root-page-layout">
        <div className="page-container">{children}</div>
      </div>
      <UserProfile toggle={onUserProfileModalToggle} isOpen={showUserProfileModal} />
      <Help toggle={onHelpModalToggle} isOpen={showHelpModal} />
      <CreateNewModal toggle={onCreateNewModalToggle} isOpen={showCreateNewModal} />
    </>
  );
};
